export default {
  MAX_WIDTH: 1100,
  MARGIN: {
    top: 35,
    bottom: 50,
    left: 60,
    right: 10,
  },
  TRACK_URL: (id: number, name: string) =>
    `/static/f1times/data/tracks/${id}/${name}.json`,
  TRACKS: [
    {
      id: 1,
      name: 'Australian Grand Prix',
    },
    {
      id: 3,
      name: 'Bahrain Grand Prix',
    },
    {
      id: 17,
      name: 'Chinese Grand Prix',
    },
    {
      id: 73,
      name: 'Azerbaijan Grand Prix',
    },
    {
      id: 4,
      name: 'Spanish Grand Prix',
    },
    {
      id: 6,
      name: 'Monaco Grand Prix',
    },
    {
      id: 7,
      name: 'Canadian Grand Prix',
    },
    {
      id: 34,
      name: 'French Grand Prix',
    },
    {
      id: 70,
      name: 'Austrian Grand Prix',
    },
    {
      id: 9,
      name: 'British Grand Prix',
    },
    {
      id: 10,
      name: 'German Grand Prix',
    },
    {
      id: 11,
      name: 'Hungarian Grand Prix',
    },
    {
      id: 13,
      name: 'Belgian Grand Prix',
    },
    {
      id: 14,
      name: 'Italian Grand Prix',
    },
    {
      id: 15,
      name: 'Singapore Grand Prix',
    },
    {
      id: 71,
      name: 'Russian Grand Prix',
    },
    {
      id: 22,
      name: 'Japanese Grand Prix',
    },
    {
      id: 32,
      name: 'Mexican Grand Prix',
    },
    {
      id: 69,
      name: 'United States Grand Prix',
    },
    {
      id: 18,
      name: 'Brazilian Grand Prix',
    },
    {
      id: 24,
      name: 'Abu Dhabi Grand Prix',
    },
  ],
}
